// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BOBj","toggle":"styles_toggle__3wiF9","preview":"styles_preview__2H5V3"};